export const updateObject = (oldObject, updatedValues, additionalValues) => {
    return {
        ...oldObject, 
        ...updatedValues,
        ...additionalValues
    }
}